export class Controller {

    /** @ngInject */
    constructor($state, DirectoriesResource) {
        this.$state = $state;
        this.DirectoriesResource = DirectoriesResource;
    }

    $onInit() {
        this.activeAccounts = this.connectionDetails.activeAccounts;
        this.pendingAccounts = this.connectionDetails.pendingAccounts;
        this.allAccounts = this.activeAccounts + this.pendingAccounts;
        this.file = null;
        this.verificationTypes = [
            {name: 'USER', selected: true},
            {name: 'ADMIN', selected: true},
            {name: 'THIRD_PARTY_FACEBOOK', selected: true},
        ];
    }

    selectCsv(csvType) {
        document.querySelector(`[ng-change*="${csvType}"]`).click();
    }

    uploadCsv(csvType) {
        const verificationTypes = this.verificationTypes
            .filter((verificationType) => verificationType.selected)
            .map((verificationType) => verificationType.name);

        this.DirectoriesResource
            .userVerification(
                this.companyId,
                this.directoryId,
                verificationTypes,
                csvType,
                this.file,
            )
            .then(({importedUsers}) => {
                this.$state.go('^.bulk-verification-result', {importedUsers}, {reload: '^'});
            });
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/bulk-verification-csv/bulk-verification-csv.controller.js